const PaymentPlanReview = {
  autopayLabel: 'Autopay',
  autopayDescription:
    'With Autopay “On,” you authorize Varo to automatically make payments from your Varo Bank Account on their due dates. Autopay is optional. You can turn it off at any time.',
  available: 'Available:',
  agreeToTerms: 'I agree and acknowledge receipt of the',
};

export default PaymentPlanReview;
